import { ReactNode } from 'react'

export enum StoreName {
  appStore = 'AppStore',
  googlePlay = 'Google Play',
  ruStore = 'RuStore',
  appGallery = 'AppGallery'
}

export enum QrStoreType {
  appStore = 'appStore',
  googlePlay = 'googlePlay',
  ruStore = 'ruStore',
  appGallery = 'appGallery'
}

export type SidebarItem = {
  className?: string
  href?: string
  icon?: ReactNode
  activeIcon?: ReactNode
  name: string
  count?: number
  isActive?: boolean
  onClick?: () => unknown
  showDot?: boolean
}

export type SidebarNavItemProps = SidebarItem & {
  className?: string
  isSidebarExpanded: boolean
}
